<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar condición</h5>
    <div mat-dialog-content>
        <!--begin::Form-->
        <form class="form" [formGroup]="editConditionForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
            <br-alert *ngIf="showAlert"></br-alert>
            <p><strong>ID: </strong>{{conditionData.id}}</p>
            <p><strong>Fecha de creación: </strong>{{conditionData.createdAt | date: 'MMMM d, y'}}</p>
            <mat-form-field class="w-100">
            <mat-label>Condición</mat-label>
            <input matInput type="text"
                formControlName="condition" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('condition', 'required')">
                <strong>Campo requerido</strong>
            </mat-error>
            </mat-form-field>
        </div>
        </form>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick(false)">Cerrar</button>
        <button mat-button cdkFocusInitial (click)="submit(editConditionForm)">Guardar</button>
    </div>
</div>